<template lang="html">
  <div style="width:100%;background-color:#f3f3f3;height:100%; position: relative">
    <div class="logo-header">
      <v-slide-x-transition mode="out-in" class="hotsite-body" v-if="logoProviderConfirmation === ''">
        <div class="titulo-logo mb-4 float-l">
          <img v-show="!loadingLogo" src="../../assets/logo.png" alt=""> <h4 v-show="!loadingLogo">CondoPlaza</h4>
        </div>
      </v-slide-x-transition>

      <v-slide-x-transition mode="out-in" class="hotsite-body" v-else>
        <img :src="logoProviderConfirmation" :key="logoProviderConfirmation" alt="">
      </v-slide-x-transition>

      <v-progress-linear v-show="loadingLogo && loading" v-bind:indeterminate="true" height="2" class="progrees-line" color="red" background-color="white"></v-progress-linear>
    </div>
    
    <v-container grid-list-md text-xs-center v-if="!loading">
      <v-layout row wrap>
        <div class="box-email">      
          <template v-if="sendEmail">                          
              <v-list two-line subheader>
                <v-subheader>{{defaultText}}</v-subheader>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{detailsScheduled.enterprise}}</v-list-tile-title>
                    <v-list-tile-sub-title>Condomínio</v-list-tile-sub-title>
                  </v-list-tile-content>                  
                </v-list-tile>          
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{detailsScheduled.scheduled}}</v-list-tile-title>
                    <v-list-tile-sub-title>Data</v-list-tile-sub-title>
                  </v-list-tile-content>                  
                </v-list-tile>  
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{detailsScheduled.category}}</v-list-tile-title>
                    <v-list-tile-sub-title>Serviço</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>            
          </template>
          <template v-else>
            <v-list two-line subheader>
                <v-subheader>{{defaultText}}</v-subheader>                
              </v-list>  
          </template>    
          <div>
            <v-btn color="success" @click="onAccept">Confirmar</v-btn>
            <v-btn color="error" @click="onCancel">Cancelar</v-btn>
          </div>  
         </div>
        </v-layout>
      </v-container>
     </v-flex>
  </div>
</template>

<script>
export default {
  props: {
    token: {
      type: String
    },
    type: {
      type: String
    },
    send: {
      type: String
    }
  },
  data () {
    return {
      loading: true,
      loadingLogo: true
    }
  },
  computed: {
    logoProviderConfirmation () {
      return this.$store.getters.logoProviderConfirmation
    },
    defaultText () {
      let text = 'Deseja cancelar o envio dos e-mails?'
      if (this.sendEmail) {
        text = 'Ao confirmar os condôminos receberão um e-mail da administradora:'
      }
      return text
    },
    detailsScheduled () {
      return this.$store.getters.detailsScheduled
    },
    sendEmail () {
      return this.send.trim().toLowerCase() === 'true'
    }
  },
  methods: {
    onAccept () {
      if (this.send.trim() === 'true') {
        this.$router.push({
          name: 'confirmacao',
          params: {
            token: this.token,
            type: this.type,
            send: this.send
          }
        })
      } else {
        this.$router.push({
          name: 'feedback',
          params: {
            token: this.token,
            type: this.type,
            send: this.send
          }
        })
      }
    },
    onCancel () {
      this.$router.push({
        name: 'cancelarEnvio',
        params: {
          token: this.token,
          type: this.type,
          send: this.send
        }
      })
    }
  },
  mounted () {
    var data = {
      token: this.token,
      type: this.type
    }
    this.$store.dispatch('getAllInfoConfirmation', data)
      .then((response) => {
        this.loadingLogo = false
      })
      .catch((err) => console.log(err))

    this.$store.dispatch('getScheduleDetails', this.token)
      .then((response) => {
        this.loading = false
      })
      .catch((err) => console.log(err))
  }
}
</script>

<style lang="css">
.box-email{
  background: #fff;
  width: 320px;
  margin: auto;
  padding: 20px;
  margin-top: 20px;
  border-radius: 20px;
}
.call-cupom {
  color: #464444;
  padding: 10px;
  font-size: 20px;
}
.cupom{
  border: 1px dashed gray;
  border-radius: 5px;
  margin: 20px;
}
.cupom input{
  font-size: 22px;
  width: 100%;
  text-align: center;
  padding: 0px 15px;
  color: #464444;
  text-transform: uppercase;
}
.texto{
	color: #42964d !important;
}
.logo-header{
    position: relative;
    width: 100%;
    text-align: center;
    padding: 20px;
    min-height: 145.63px;
    background-color: #fff;
}
.logo-header img, .administrator{
  max-width: 200px;
  max-height: 100px;
}
.titulo-logo{
  width: 300px;
  margin: auto;
}
.titulo-logo h4 {
  width: calc(100% - 80px);
  color: #a2a2a2;
  float: left;
  position: relative;
  top: 11px;
  font-size: 39px;
  left: 2px;
}
.titulo-logo img {
  width: 80px;
  height: 80px;
  float: left;
}
.progrees-line{
  position: absolute;
  bottom:0;
  margin: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// previa.vue?0db6c8bc